<template>
  <van-pull-refresh v-model="isLoading" @refresh="() => { initExamList(); searchMessage() }">
    <van-notice-bar left-icon="volume-o" :text="msg" v-if="messageList.length > 0"/>
    <div class="home">
      <div class="content">
        <div v-if="type != 14">
          <div class="STitle">考试</div>
          <span>
            <van-search v-model="searchValue" placeholder="请输入搜索关键词" show-action @search="onSearchJ" class="mySearch"
              enterkeyhint="search">
              <div slot="action" @click="onSearchJ"></div>
            </van-search>
          </span>
          <van-empty v-if="examList.length == 0" description="当前无考试项目" />
          <div class="tab-item">
            <van-card class="itemI" :class="item.showTesting ? 'showTesting' : ''" v-for="item in examList"
              :key="item.id" @click="toExam2(item, 1)">
              <template #thumb>
                <van-image style="width:100%;margin:auto;padding-right:8px;max-height: 100px" fit="fill" lazy-load
                  :src="item.mode1_url" />
              </template>
              <template #title>
                <span style="font-size: 14px;font-weight: bold">{{ item.exam_name }}</span>
              </template>
              <template #desc>
                <div style="padding-top: 20px;font-size: 12px">
                  <span>题目数量:{{ item.subject_count }}</span>
                  <!--   <span>及格分数:{{item.pass_score}} </span>-->
                </div>
              </template>
              <template #tags>
                <div style="padding-top: 10px;font-size: 12px">
                  <span class="new-price">已考次数:{{ item.user_exam_total ? item.user_exam_total : 0 }}</span>
                  <span class="new-price" style="padding-left: 5px" v-if="item.exam_max == 0">剩余次数:无限</span>
                  <span class="new-price" style="padding-left: 5px" v-else>剩余次数:{{ item.exam_max -
                    item.user_exam_total > 0 ? item.exam_max - item.user_exam_total : 0 }}</span>
                </div>
                <div style="padding-top: 10px;font-size: 12px">
                  <!--                <span class="new-price">最近一次考试成绩率:{{item.score_rate?(item.score_rate*100).toFixed(0):0}}%</span>-->
                  <span class="new-price">最近一次考试成绩:{{ item.user_score ? item.user_score : 0 }}</span>
                </div>
              </template>
            </van-card>
          </div>
        </div>

        <div v-if="type == 14">
          <div class="STitle" v-if="type != 13">练习</div>
          <span>
            <van-search v-model="searchValue" placeholder="请输入搜索关键词" show-action @search="onSearchJ" class="mySearch"
              enterkeyhint="search">
              <div slot="action" @click="onSearchJ"></div>
            </van-search>
          </span>
          <div class="tab-item" v-if="type != 13">
            <van-card class="itemI" v-for="item in examList" :key="item.id" @click="toExam2(item, 0)">
              <template #thumb>
                <van-image style="width:100%;margin:auto;padding-right:8px" fit="contain" lazy-load
                  :src="item.mode0_url" />
              </template>
              <template #title>
                <span style="font-size: 14px;font-weight: bold">{{ item.exam_name }}</span>
              </template>
              <template #tags>
                <div style="padding-top: 50px">
                  <span>题目数量:{{ item.subject_count }}</span>
                  <!--<span>及格分数:{{item.pass_score}} </span>-->
                </div>
              </template>
            </van-card>
          </div>
        </div>

      </div>
      <yq-tabbar :active="1"></yq-tabbar>
    </div>
  </van-pull-refresh>
</template>

<script>
import { Dialog } from 'vant';
import { examListGet, examStart, messagesGet } from '@/api/shopapi';
import yqTabbar from '@/components/yq-tabbar.vue';
const moment = require('moment');

export default {
  data() {
    return {
      isLoading: false,
      examList: [],
      examInfo: {},
      type: 0,
      info_id: null,
      searchValue: '',
      messageList: [],
      autoplay: 5000,
      msgIndex: 0
    };
  },
  components: {
    yqTabbar
  },
  computed: {
    msg () {
      try {
        return this.messageList[this.msgIndex].message
      } catch (error) {
        return null
      }
    }
  },
  async activated() {
    await this.initExamList()
    await this.searchMessage()
    if (this.messageList.length > 1) {
      setInterval(() => {
        if(this.msgIndex == this.messageList.length - 1) {
          this.msgIndex = 0
        } else {
          this.msgIndex++
        }
      }, 20000)
    }
  },
  methods: {
    async searchMessage () {
      const list = await messagesGet({ "page_no": 0,  "page_size": 999 })
      this.messageList = list.data.data_list
      this.msgIndex = 0
    },
    async initExamList() {
      this.type = this.$store.getters.getExamType
      this.info_id = parseInt(this.$route.query.info_id)
      let para = {}
      if (this.type == 14) {
        para = {
          mode: 0,
          page_no: 0,
          page_size: 99999,
          type: null
        }
      } else {
        para = {
          mode: 1,
          page_no: 0,
          page_size: 99999,
          type: null
        }
      }
      para.info_id = this.info_id ? this.info_id : null
      const examListGetRes = await examListGet(para)
      if (examListGetRes.code === '000') {
        this.examList = [...examListGetRes.data.data_list]
        this.examInfo = Object.assign({}, examListGetRes.data.data_list[0])
      } else {

        this.$toast.fail('\'获取试题列表\\n失败\'')
      }
      let examCatch = JSON.parse(localStorage.getItem('exam'))
      if (examCatch) {
        let obj = this.examList.find(x => {
          return x.exam_id == examCatch.examInfo.exam_id
        })
        if (!obj) {
          localStorage.removeItem('exam')
        } else {
          this.examList.map(v => {
            if (v.exam_id == examCatch.examInfo.exam_id) {
              v.showTesting = true
            }
          })
        }
      }
      this.isLoading = false
    },
    async toExamDeatailTest(item, ifTest) {
      let examInfo = JSON.parse(localStorage.getItem('examInfo'))
      console.log('33333333333---------', examInfo)
      if (examInfo && examInfo.exam_id !== item.exam_id) {//存在未完成的考试
        this.examList.map(v => {
          if (v.exam_id == examInfo.exam_id) {
            v.showTesting = true
          }
        })
        console.log('kaoshizhong', examInfo.exam_id)
        this.$toast.fail({
          duration: 2000, // 持续展示 toast
          forbidClick: true,
          message: '上一套考试\n未完成\n无法开始\n新考试',
        })
      } else if (examInfo && examInfo.exam_id == item.exam_id) {
        this.$router.push({ name: 'examDetail', params: { ifKeep: true, upFlag: true, type: this.type } })

      } else {
        if (item.reexamine) {//是否允许重复考试
          if (item.exam_max > 0 && item.user_exam_total == item.exam_max) {
            this.$toast.fail({
              duration: 2000, // 持续展示 toast
              forbidClick: true,
              message: '没有考试次数了',
            })
          } else {
            localStorage.removeItem('currendIndex')
            localStorage.removeItem('saveAnswer')
            localStorage.removeItem('examInfo')
            this.$store.dispatch("setCurrendIndex", [0]);
            this.$store.dispatch("setSaveAnswer", [[]]);
            let para = {
              mode: 1,
              exam_id: item.exam_id,
            }
            const examRes = await examStart(para)
            if (examRes.code === '000') {
              if (examRes.code === '000') {
                let examInfo = Object.assign({}, examRes.data);
                examInfo.ifTest = ifTest
                examInfo.user_end_time = item.user_end_time
                examInfo.user_exam_id = item.user_exam_id
                examInfo.mode1_start_time = item.mode1_start_time
                examInfo.mode1_end_time = item.mode1_end_time
                this.$store.dispatch("setExamInfo", examInfo);
                localStorage.setItem('examInfo', JSON.stringify(examInfo));
                this.$router.push({ name: 'examDetail', params: { ifKeep: false, upFlag: true, type: this.type } })
              }
            } else {
              this.$toast.fail(examRes.message)
            }
          }
        } else {
          if (item.user_pass_time) {
            this.$toast.success({
              duration: 2000, // 持续展示 toast
              forbidClick: true,
              message: '您已完成考试',
            })
          } else {
            if (item.exam_max > 0 && item.user_exam_total == item.exam_max) {
              this.$toast.fail({
                duration: 2000, // 持续展示 toast
                forbidClick: true,
                message: '没有考试次数了',
              })
            }
            else if ((item.user_score < item.pass_score) && item.user_exam_total > 0 && item.exam_max != 0) {
              this.$toast.fail({
                duration: 2000, // 持续展示 toast
                forbidClick: true,
                message: '您没有考试机会了',
              })
            }
            else {
              localStorage.removeItem('currendIndex')
              localStorage.removeItem('saveAnswer')
              localStorage.removeItem('examInfo')
              this.$store.dispatch("setCurrendIndex", [0]);
              this.$store.dispatch("setSaveAnswer", [[]]);
              let para = {
                mode: 1,
                exam_id: item.exam_id,
              }
              const examRes = await examStart(para)
              if (examRes.code === '000') {
                if (examRes.code === '000') {
                  let examInfo = Object.assign({}, examRes.data);
                  examInfo.ifTest = ifTest
                  examInfo.user_end_time = item.user_end_time
                  examInfo.user_exam_id = item.user_exam_id
                  examInfo.mode1_start_time = item.mode1_start_time
                  examInfo.mode1_end_time = item.mode1_end_time
                  this.$store.dispatch("setExamInfo", examInfo);
                  localStorage.setItem('examInfo', JSON.stringify(examInfo));
                  this.$router.push({ name: 'examDetail', params: { ifKeep: false, upFlag: true, type: this.type } })
                }
              } else {
                console.log(examRes.message)
                this.$toast.fail(examRes.message)
              }
            }
          }

        }
      }
    },
    async toExamDeatailPractice(item, ifTest) {
      localStorage.removeItem('currendIndex')
      localStorage.removeItem('saveAnswer')
      localStorage.removeItem('examInfo')
      this.$store.dispatch("reSetCurrendIndex");
      this.$store.dispatch("reSetSaveAnswer");
      let examInfo = JSON.parse(localStorage.getItem('examInfop'))
      if (examInfo && examInfo.exam_id !== item.exam_id) {
        this.$dialog.confirm({
          message: '您上次练习未结束，是否放弃上次练习？点击确认放弃',
        }).then(() => {
          console.log('放弃')
          localStorage.removeItem('examInfop')
          this.toExamDeatailPractice(item, ifTest)
        })
          .catch(() => {
            console.log('不放弃')
          });
      } else {
        if (examInfo) {
          examInfo.ifTest = ifTest
          this.$store.dispatch("setExamInfo", examInfo);
          this.$router.push({ name: 'examDetail', params: { ifKeep: true, upFlag: true, type: this.type } })
        } else {
          let para = {
            mode: 0,
            exam_id: item.exam_id,
          }
          const examRes = await examStart(para)
          if (examRes.code === '000') {
            let examInfo = Object.assign({}, examRes.data);
            examInfo.ifTest = ifTest
            console.log('resindex', examInfo)
            this.$store.dispatch("setExamInfo", examInfo);
            localStorage.setItem('examInfop', JSON.stringify(examInfo));
            this.$router.push({ name: 'examDetail', params: { ifKeep: false, upFlag: true, type: this.type } })
          } else {
            console.log(examRes.message)
            this.$toast.fail(examRes.message)
          }
        }
      }
    },
    confirmExam(item, ifTest) {
      if (item.showTesting) {
        this.toExamDetail(item, ifTest)
      } else {
        Dialog.confirm({
          title: '开始考试',
          message: '确定开始考试?',
          confirmButtonText: '开始',
          cancelButtonText: '取消'
        }).then(() => {
          this.toExamDetail(item, ifTest)
        }).catch(() => { })
      }
    },
    async toExamDetail(item, ifTest) {
      console.log('item', item)
      this.examInfo.ifTest = ifTest
      if (ifTest) {
        let time = moment(new Date())
        let startTime = moment(item.mode1_start_time)
        let endTime = moment(item.mode1_end_time)
        if (item.mode1_start_time) {
          if (item.mode1_end_time) {
            if (time.isBetween(startTime, endTime)) {
              this.toExamDeatailTest(item, ifTest)
            } else {
              if (time.isBefore(startTime)) {
                this.$toast.fail({ message: '考试时间未到' })
              }
              else {
                this.$toast.fail({ message: '考试已结束' })
              }
            }
          } else {
            if (time.isAfter(startTime)) {
              this.toExamDeatailTest(item, ifTest)
            } else {
              this.$toast.fail({ message: '考试时间未到' })
            }
          }
        } else {
          if (item.mode1_end_time) {
            if (time.isAfter(endTime)) {
              this.$toast.fail({ message: '考试已结束' })
            } else {
              this.toExamDeatailTest(item, ifTest)
            }
          } else {
            this.toExamDeatailTest(item, ifTest)
          }
        }
      } else {
        if (item.mode0_disable_list) {
          let flagArr = item.mode0_disable_list.filter(function (v, index) {
            let time = moment(new Date())
            let startTime = moment(v.start_time)
            let endTime = moment(v.end_time)
            if (time.isBetween(startTime, endTime)) {
              return v
            }
          })
          if (flagArr.length > 0) {
            this.$toast.fail({ message: '当前时间无法练习' })
          } else {
            this.toExamDeatailPractice(item, ifTest)
          }
        } else {
          this.toExamDeatailPractice(item, ifTest)
        }
      }
    },
    async onSearchJ() {
      let para = {}
      if (this.type == 14) {
        para = {
          mode: 0,
          page_no: 0,
          page_size: 99999,
          type: null,
          exam_name: this.searchValue
        }
      } else {
        para = {
          mode: 1,
          page_no: 0,
          page_size: 99999,
          type: null,
          exam_name: this.searchValue
        }
      }
      para.info_id = this.info_id ? this.info_id : null
      const examListGetRes = await examListGet(para)
      if (examListGetRes.code === '000') {
        this.examList = [...examListGetRes.data.data_list]
        this.examInfo = Object.assign({}, examListGetRes.data.data_list[0])
      } else {
        this.$toast.fail('获取试题列表\n失败')
      }
    },
    compareTime(t1, t2) {
      var text;
      var n = new Date().getTime()
      var st, et;
      if (t1) {
        st = new Date(t1).getTime() ? new Date(t1).getTime() : new Date(t1.replace(/-/g, '/')).getTime();
      }
      if (t2) {
        et = new Date(t2).getTime() ? new Date(t2).getTime() : new Date(t2.replace(/-/g, '/')).getTime();
      }
      if (n < st && t1) {
        text = '未开始'
      }
      if (n > et && t2) {
        text = '已结束'
      }
      return text
    },
    toExam2(item, mode) {
      var sign = true
      // 是否不在考试时间内
      var signText = this.compareTime(item.mode1_start_time, item.mode1_end_time)
      if (signText) {
        this.$toast.fail({ message: '考试' + signText })
        return sign = false
      }
      // 上套试卷未完成，不能进行下一套
      var examCatch = localStorage.getItem('exam') ? JSON.parse(localStorage.getItem('exam')) : null
      if (examCatch && (item.exam_id != examCatch.examInfo.exam_id)) {
        this.$toast.fail({ message: '上一套考试未完成，无法开始新考试' })
        return sign = false
      }
      // 允许重考只要有次数一直考
      if (item.reexamine) {
        if (item.exam_max > 0 && item.user_exam_total == item.exam_max) {
          this.$toast.fail({ message: '您没有考试次数了' })
          return sign = false
        }
      } else {
        // 有通过的考试，就不能再考了
        if (item.user_pass_time) {
          this.$toast.fail({ message: '已完成考试了' })
          return sign = false
        } else {
          // 没次数了
          if (item.exam_max > 0 && item.user_exam_total == item.exam_max) {
            this.$toast.fail({ message: '您没有考试次数了' })
            return sign = false
          }
          // 没通过并且考过一次的，不是无限考的
          if ((item.user_score < item.pass_score) && item.user_exam_total > 0 && item.exam_max != 0) {
            this.$toast.fail({ message: '您没有考试机会了' })
            return sign = false
          }
        }
      }
      if (sign) {
        Dialog.confirm({
          title: '开始考试',
          message: '确定开始考试?',
          confirmButtonText: '开始',
          cancelButtonText: '取消'
        }).then(() => {
          this.$router.push({ name: 'examDetail', params: { id: item.exam_id, count: item.subject_count, mode: mode, name: item.exam_name, endTime: item.mode1_end_time } })
        }).catch(() => { })
      }
    }
  }
};
</script>
<style scoped>
.home {
  background-color: #ffffff;
  height: calc(100vh - 96px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.home-swipe {
  box-sizing: border-box;
  padding: 4px 6px;
  background-color: #fff;
  border-bottom: 1px solid #dedede;
}

.home-swipe-head {
  padding: 4px 0;
}

.swipe img {
  width: 100%;
  height: 100%;
}

.good-item {
  padding: 5rem 1.3rem 5rem 1.3rem !important;
  /* background: url(../../../static/img/health/secbg.jpg) no-repeat ; */
  background-size: 100%;
  /*    height: 500px;*/
  /* margin-bottom: 6px*/
}

.content {
  width: 100%;
  z-index: 2;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  position: relative;
  background-color: #f6f6f6;
  overflow: scroll;
  flex: 1;
  display: block;
}

.tab-item {
  display: flex;
  flex-wrap: wrap;
  background-color: #f6f6f6;


}

.item {
  width: 50%;
  margin-bottom: 12px;
  line-height: 0px;
}

.item-detail {
  line-height: normal;
  position: relative;
  background-color: white;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}

.item:nth-child(even)>.item-detail {
  margin-right: 12px;
  margin-left: 6px;
}

.item:nth-child(odd)>.item-detail {
  margin-left: 12px;
  margin-right: 6px;
}

/* .item-detail::before{
    content:'今日上新';
    position: absolute;
    background-color:#E7153A;
    color: #fff;
    font-size: 12px;
    line-height: 24px;
    display: inline-block;
    text-align: center;
    width: 60px;
    z-index:10;
    border-top-left-radius:5px;
    border-bottom-right-radius:5px
  }*/
.item-detail>>>img {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}

.item-detail>>>.van-image__error {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}

.item-detail img {
  width: 100%;
}

.item-detail .desc {
  padding: 4px;
  font-size: 14px;
  height: 10px;
  display: -webkit-boxl;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-weight: bold;
}

.item-detail .new-price {
  margin-left: 2px;
  color: gray;
  font-size: 12px;
  font-weight: bolder;
}

.item-detail .old-price {
  font-size: 12px;
  color: #333;
  margin-left: 6px;
}

.topDes {
  padding: 10px 26px;
}

.topDesHeader {
  color: #E7153A;
  font-weight: bolder;
  font-size: 20px;
  padding-bottom: 4px;
}

.topDesMsg {
  color: gray;
}

.STitle {
  padding: 10px 45px;
  font-size: 18px;
  font-weight: bold;
  position: relative;
}

.STitle::before {
  content: counter(sub-item, disc);
  display: block;
  color: #E7153A;
  font-size: 24px;
  position: absolute;
  left: 0.8rem
}

.price {
  padding: 10px 5px;
  text-align: center;
}

.itemI {
  width: 100%;
}

.itemI .van-card__thumb {
  width: 140px;
  max-height: 80px;
}

.itemI .van-card__thumb>>>img {
  border-radius: 5px !important;
  max-height: 80px;
}

.itemI .van-card__thumb .van-image {

  max-height: 80px !important;
}

.showTesting::before {
  content: '正在考试';
  background-color: #8AB948;
  /*   width: 100%;
       height: 100%;*/
  position: absolute;
  opacity: 1 !important;
  z-index: 99;
  left: 16px;
  top: 0;
  font-size: 14px;
  text-align: center;
  color: white;
  height: 35px;
  width: 30px;
  border-radius: 0 0 20px 20px;
  padding: 5px 10px 10px 10px;
}

.coming::before {
  content: '未开始';
  background-color: #8AB948;
  /*   width: 100%;
       height: 100%;*/
  position: absolute;
  opacity: 1 !important;
  z-index: 99;
  left: 16px;
  top: 0;
  font-size: 14px;
  text-align: center;
  color: white;
  height: 35px;
  width: 30px;
  border-radius: 0 0 20px 20px;
  padding: 5px 10px 10px 10px;
}

.end::before {
  content: '已结束';
  background-color: #8AB948;
  /*   width: 100%;
       height: 100%;*/
  position: absolute;
  opacity: 1 !important;
  z-index: 99;
  left: 16px;
  top: 0;
  font-size: 14px;
  text-align: center;
  color: white;
  height: 35px;
  width: 30px;
  border-radius: 0 0 20px 20px;
  padding: 5px 10px 10px 10px;
}

.mySearch {
  position: absolute;
  top: 0;
  width: 75%;
  background: transparent !important;
  left: 25%;
  font-size: 12px;
  z-index: 101
}

.mySearch .van-cell {
  padding: 0px !important;
}

.mySearch .van-search__content {
  border: 1px solid red;
  border-radius: 15px;
}
.notice-swipe {
  height: 40px;
  line-height: 40px;
}
</style>
